export default function AdminFinance(){return <div className='p-8'>Admin Finance</div>}